import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

function Division() {
  return (
    <SettingsMetaData propertyName={"Division_invoices"} viewPropertyName={"Division"} />

  )
}

export default Division